import React from 'react';
import PropTypes from 'prop-types';
import { get, noop } from 'lodash';
import { compose, setDisplayName } from 'recompose';

import { GhostIndicator } from 'base-components';
import { Row, Column } from 'styled-components-reactive-grid';

import withInboundProgram from 'compositions/CaseRequestsPanel/RequestAssetsForm/withInboundProgram';

import DropdownCell from '../DropdownCell';
import withRequestAssets from './withRequestAssets';

export function UnitOptionsDropdownCell(props) {
  const { value, onChange, options, isLoading } = props;

  if (isLoading) {
    return (
      <Row>
        <Column modifiers="col">
          <GhostIndicator />
        </Column>
      </Row>
    );
  }

  return (
    <DropdownCell
      {...{
        ...props,
        value: get(value, 'id') || '',
        options,
        onChange: id => onChange(options.find(option => option.id === id)),
      }}
    />
  );
}

UnitOptionsDropdownCell.propTypes = {
  isUsxpress: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.shape({}),
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

UnitOptionsDropdownCell.defaultProps = {
  value: undefined,
  onChange: noop,
};

export default compose(
  setDisplayName('UnitOptionsDropdownCell'),
  withRequestAssets,
  withInboundProgram,
)(UnitOptionsDropdownCell);



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestLines/BaseRequestLinesTable/UnitOptionsDropdownCell/index.js